import { defineComponent as _defineComponent } from 'vue'
import { FLAG_IMPRESSIONS_PRODUCTS } from "@/utils/experiments/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'TrackProductImpression',
  setup(__props) {


return { __sfc: true,FLAG_IMPRESSIONS_PRODUCTS }
}

})